import { neverGuard } from "@1js/functional/lib/functional";
import { LokiUrl } from "./LokiUrl";
export function getLokiDomainFromComplianceEnvironment(complianceEnvironment) {
    switch (complianceEnvironment) {
        case "Df":
            return LokiUrl.Dogfood;
        case "Msit":
            return LokiUrl.MSIT;
        case "Blackforest":
            return LokiUrl.Blackforest;
        case "GccModerate":
            return LokiUrl.GccModerate;
        case "GccHigh":
            return LokiUrl.GccHigh;
        case "DoD":
            return LokiUrl.DOD;
        case "Gallatin":
            return LokiUrl.Gallatin;
        case "Prod":
            return LokiUrl.TopLevel;
        case "AG08":
            return LokiUrl.AG08;
        case "AG09":
            return LokiUrl.AG09;
        case "Unknown":
            // This is the ultimate solution when we are not able to figure out from which environment we
            // are making the call and we don't want to default to top level domain. For example Win32.
            throw new Error("'Unknown' is not an expected environment type in Loki");
        default:
            return neverGuard(complianceEnvironment);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0TG9raURvbWFpbkZyb21Db21wbGlhbmNlRW52aXJvbm1lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0TG9raURvbWFpbkZyb21Db21wbGlhbmNlRW52aXJvbm1lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGdDQUFnQyxDQUFDO0FBRTVELE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFFcEMsTUFBTSxVQUFVLHNDQUFzQyxDQUNwRCxxQkFBc0M7SUFFdEMsUUFBUSxxQkFBcUIsRUFBRTtRQUM3QixLQUFLLElBQUk7WUFDUCxPQUFPLE9BQU8sQ0FBQyxPQUFPLENBQUM7UUFDekIsS0FBSyxNQUFNO1lBQ1QsT0FBTyxPQUFPLENBQUMsSUFBSSxDQUFDO1FBQ3RCLEtBQUssYUFBYTtZQUNoQixPQUFPLE9BQU8sQ0FBQyxXQUFXLENBQUM7UUFDN0IsS0FBSyxhQUFhO1lBQ2hCLE9BQU8sT0FBTyxDQUFDLFdBQVcsQ0FBQztRQUM3QixLQUFLLFNBQVM7WUFDWixPQUFPLE9BQU8sQ0FBQyxPQUFPLENBQUM7UUFDekIsS0FBSyxLQUFLO1lBQ1IsT0FBTyxPQUFPLENBQUMsR0FBRyxDQUFDO1FBQ3JCLEtBQUssVUFBVTtZQUNiLE9BQU8sT0FBTyxDQUFDLFFBQVEsQ0FBQztRQUMxQixLQUFLLE1BQU07WUFDVCxPQUFPLE9BQU8sQ0FBQyxRQUFRLENBQUM7UUFDMUIsS0FBSyxNQUFNO1lBQ1QsT0FBTyxPQUFPLENBQUMsSUFBSSxDQUFDO1FBQ3RCLEtBQUssTUFBTTtZQUNULE9BQU8sT0FBTyxDQUFDLElBQUksQ0FBQztRQUN0QixLQUFLLFNBQVM7WUFDWiw2RkFBNkY7WUFDN0YsMkZBQTJGO1lBQzNGLE1BQU0sSUFBSSxLQUFLLENBQUMsdURBQXVELENBQUMsQ0FBQztRQUMzRTtZQUNFLE9BQU8sVUFBVSxDQUFDLHFCQUFxQixDQUFDLENBQUM7S0FDNUM7QUFDSCxDQUFDIn0=